export const setAuthToken = (token) => {
  if (token) {
    // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('token', JSON.stringify(token));
  } else {
    localStorage.removeItem('token');
  }
};
